import requestUtil from '../../helpers/requestUtil';
import { setLoading } from '../common/Loader/slice';
import { reset, resetError, setChat, setError, setMessages, setMsgSendFlag } from './slice';

export function resetErrorStatus() {
    return async dispatch => {
        dispatch(resetError());
    };
}

export function getMessagesData({ url, params }) {
    return async dispatch => {
        dispatch(setLoading(true));
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            dispatch(setMessages(response));
        } catch (error) {
            dispatch(setError(error.message))
        }
        dispatch(setLoading(false));
    };
}

export const getPersonalMsg = ({ url, params }) => {
    return async dispatch => {
        dispatch(setLoading(true));
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            dispatch(setChat(response.appMessages));
        } catch (error) {
            dispatch(setError(error.message))
        }
        dispatch(setLoading(false));
    }
}

export const sendPersonal = ({ url, params }) => {
    return async dispatch => {
        dispatch(setLoading(true));
        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            dispatch(setMsgSendFlag(true));
        } catch (error) {
            dispatch(setMsgSendFlag(false))
            dispatch(setError(error.message))
        }
        dispatch(setLoading(false));
    }
}

export const updateMsgFlag = (flag) => {
    return async dispatch => {
        dispatch(setMsgSendFlag(flag));
    }
}

export const clearData = () => {
    return async dispatch => {
        dispatch(reset());

    }
}